import Swiper, { Pagination, Navigation, FreeMode, Grid } from 'swiper';

export default {
  init() {
    // JavaScript to be fired on all pages
    //plugin bootstrap minus and plus
    //http://jsfiddle.net/laelitenetwork/puJ6G/
    $(function() {
//        var MTUserId='b92658cc-657a-426a-8408-d866d1ab7082';
//        var MTFontIds = new Array();
//
//        MTFontIds.push('5219390'); // Century Gothic� W05 Bold 
//        MTFontIds.push('5321689'); // Century Gothic� W05 Regular 
//        (function() {
//            var mtTracking = document.createElement('script');
//            mtTracking.type='text/javascript';
//            mtTracking.async='true';
//            mtTracking.src='mtiFontTrackingCode.js';
//
//            (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(mtTracking);
//        })();
        
        $('.nav-mobile-toggler.hamburger').on('click', function() {
            $(this).toggleClass('is-active');
            $($(this).data('target')).toggleClass('show');
        })
        
        $('.woocommerce').on('click', '.btn-qty', function(e) {
            e.preventDefault();

            var fieldName = $(this).attr('data-field');
            var type      = $(this).attr('data-type');
            var input = $('input[name="'+fieldName+'"]');
            var currentValue = parseInt(input.val());
            if (!isNaN(currentValue)) {
                if(type == 'minus') {
                    if(currentValue > input.attr('min')) {
                        input.val(currentValue - 1).change();
                    } 
                    if(parseInt(input.val()) == input.attr('min')) {
                        $(this).attr('disabled', true);
                    }
                }
                else if (type == 'plus') {
                    if (!isNaN(parseInt(input.attr('max')))) {
                        if(currentValue < input.attr('max')) {
                            input.val(currentValue + 1).change();
                        }
                        if(parseInt(input.val()) == input.attr('max')) {
                            $(this).attr('disabled', true);
                        }
                    }
                    else {
                        input.val(currentValue + 1).change();
                    }
                }
            }
            else if (!isNaN(input.attr('min'))) {
                input.val(input.attr('min'));
            }
            else {
                input.val(0);
            }
        });
        $('.woocommerce').on('change', '.input-qty', function() {
            var minValue =  parseInt($(this).attr('min'));
            var maxValue =  parseInt($(this).attr('max'));
            var currentValue = parseInt($(this).val());

            if (isNaN(currentValue)) {
                return;
            }

            var name = $(this).attr('name');
            if (currentValue > minValue) {
                $('.btn-qty[data-type="minus"][data-field="'+name+'"]').removeAttr('disabled')
            }
            else if (currentValue == minValue) {
                $('.btn-qty[data-type="minus"][data-field="'+name+'"]').attr('disabled', 'disabled')
            }
            else if (currentValue < minValue) {
                $(this).val($(this).data(minValue));
            }
            if (!isNaN(maxValue)) {
                if (currentValue < maxValue) {
                    $('.btn-qty[data-type="plus"][data-field="'+name+'"]').removeAttr('disabled')
                }
                else if (currentValue == maxValue) {
                    $('.btn-qty[data-type="minus"][data-field="'+name+'"]').attr('disabled', 'disabled')
                }
                else if (currentValue > maxValue) {
                    $(this).val($(this).data(maxValue));
                }
            }
        });
        
//        $('.input-qty').keydown(function (e) {
//            // Allow: backspace, delete, tab, escape, enter and .
//            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
//                 // Allow: Ctrl+A
//                (e.keyCode == 65 && e.ctrlKey === true) || 
//                 // Allow: home, end, left, right
//                (e.keyCode >= 35 && e.keyCode <= 39)) {
//                     // let it happen, don't do anything
//                     return;
//            }
//            // Ensure that it is a number and stop the keypress
//            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
//                e.preventDefault();
//            }
//        });

        Swiper.use([Pagination, Navigation, FreeMode, Grid]);
        const swiper = new Swiper('.product-category-slider .swiper-container', {
//                preventClicksPropagation: false,
//                threshold: 25,
//                simulateTouch: false,
//            slideToClickedSlide: true,
            grabCursor: true,
//            centeredSlides: true,
            slidesPerView: 'auto',
            freeMode: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
        });
        const swiper2 = new Swiper('.photo-gallery .swiper-container', {
            preventClicksPropagation: false,
            grabCursor: true,
//            slidesPerView: 'auto',
//            slidesPerGroup: 1,
//            slidesPerGroupAuto: true,
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 15,
            grid: {
              rows: 4,
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
        });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js